import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import CenterSpinner from '../../components/CenterSpinner';
import {
  ColumnHeaderType,
  LoggedUserType,
  UserType,
  ViewLeadsFilterType,
} from '../../utils/Types';
import KTable from '../../components/KTable';
import {
  API_STATUS,
  CLICK_ACTIONS,
  DEFAULT_PAGE_SIZE,
  LIST_VIEW_ITEM,
  TASK_ACTION,
} from '../../utils/Constant';
import KPagination from '../../components/KPagination';
import ViewLeadsFilter from '../../filters/ViewLeadsFilter';
import { VIEW_Leads_HEADER } from '../../utils/TableHeaderConstants';
import {
  fetchLeadList,
  leadApiStatus,
  leadSelector,
} from '../../features/leadSlice';
import {
  dashboardSelector,
  updateListViewItemsStatus,
} from '../../features/dashboardSlice';
import { loginSelector } from '../../features/loginSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import classNames from 'classnames';
import ToggleSwitch from '../../components/ToggleSwitch';
import CreateLeadPage from './CreateLeadPage';
import { getViewLeadRequest } from './LeadPageHelper';

const ViewLeadsPage: React.FunctionComponent = () => {
  const [viewLead, setViewLead] = useState(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [selectedFilter, setSelectedFilter] = useState<ViewLeadsFilterType>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedLead, setSelectedLead] = useState<any>();
  const listOrView = useAppSelector(dashboardSelector).listOrView;

  const dispatch = useAppDispatch();
  const taskDataList = useAppSelector(leadSelector).leadListData.result ?? [];
  const pagination = useAppSelector(leadSelector).leadListData.pagination;
  const apiStatus = useAppSelector(leadApiStatus);
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const [showFilter, setShowFilter] = useState<boolean>(true);

  const onTableAction = (param: any, header: ColumnHeaderType) => {
    if (header.action === CLICK_ACTIONS.VIEW_LEAD) {
      setSelectedLead(param);
      setViewLead(true);
      dispatch(updateListViewItemsStatus(LIST_VIEW_ITEM.VIEW_ITEM));
    }
  };
  const onTaskAction = (action: string) => {
    if (action === CLICK_ACTIONS.CLOSE_VIEW_LEAD) {
      setViewLead(false);
      dispatch(updateListViewItemsStatus(LIST_VIEW_ITEM.LIST_ITEMS));
    }
  };
  const getLeadList = () => {
    dispatch(
      fetchLeadList(
        getViewLeadRequest(
          currentPage,
          pageSize,
          user,
          userDetails,
          selectedFilter
        )
      )
    );
  };

  useEffect(() => {
    if (listOrView === LIST_VIEW_ITEM.LIST_ITEMS) {
      setViewLead(false);
      getLeadList();
    }
  }, [listOrView]);

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  useEffect(() => {
    if (userDetails?.roleid) getLeadList();
  }, [pageSize, currentPage, selectedFilter, userDetails, user]);

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <>
      {!viewLead && (
        <div className="ml-4">
          <Label className="text-heading">View Lead</Label>
          <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
          <div className="task-item-parent-view">
            {showFilter && (
              <ViewLeadsFilter
                onApplyFilters={(filter: ViewLeadsFilterType) => {
                  setSelectedFilter(filter);
                  setCurrentPage(1);
                }}
              />
            )}
            <div className="mt-4">
              <KTable
                tableParentClass={classNames('table-parent-view-leads', {
                  hideFilters: !showFilter,
                })}
                data={taskDataList}
                columnHeader={VIEW_Leads_HEADER}
                onAction={onTableAction}
                noDataFoundMsg="No Leads to Display"
                isLoading={showLoader}
              />
              {taskDataList && taskDataList.length > 0 && (
                <KPagination
                  totalPages={pagination?.totalPages}
                  currentPage={pagination?.currentPage}
                  pageSize={pagination?.pageSize}
                  onPageChange={setCurrentPage}
                  onSizeChange={setPageSize}
                  fromItem={pagination?.fromItem}
                  toItem={pagination?.toItem}
                  totalItems={pagination?.totalItems}
                />
              )}
            </div>
          </div>

          <CenterSpinner showLoader={showLoader} />
        </div>
      )}
      {viewLead && (
        <CreateLeadPage
          title="View Lead"
          onTaskAction={onTaskAction}
          leadStatusName={TASK_ACTION.VIEW}
          leadToView={selectedLead}
        />
      )}
    </>
  );
};

export default ViewLeadsPage;
